import {
  STRUC_BULK_CREATE_STRUC_LIST_START,
  STRUC_BULK_CREATE_STRUC_LIST_SUCCESS,
  STRUC_BULK_CREATE_STRUC_LIST_FAIL,
  STRUC_BULK_CREATE_EXISTING_START,
  STRUC_BULK_CREATE_EXISTING_SUCCESS,
  STRUC_BULK_CREATE_EXISTING_FAIL,
  STRUC_BULK_CREATE_STRUC_LIST_RESET,
  STRUC_BULK_CREATE_SET_GRID_STORE
} from './StructureBulkCreateActions';

export const initialState = {
  strucList: [],
  retrieveStructuresFail: false,
  retrieveStructuresLoading: false,
  retrieveStructuresSuccess: false,
  bulkCreateFail: false,
  bulkCreateLoading: false,
  bulkCreateSuccess: false,
  gridStore: {}
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case STRUC_BULK_CREATE_STRUC_LIST_START:
      return {
        ...state,
        retrieveStructuresFail: false,
        retrieveStructuresSuccess: false,
        retrieveStructuresLoading: true
      };
    case STRUC_BULK_CREATE_STRUC_LIST_SUCCESS:
      return {
        ...state,
        retrieveStructuresFail: false,
        retrieveStructuresSuccess: true,
        retrieveStructuresLoading: false,
        strucList: action.structures
      };

    case STRUC_BULK_CREATE_STRUC_LIST_FAIL:
      return {
        ...state,
        retrieveStructuresFail: true,
        retrieveStructuresSuccess: false,
        retrieveStructuresLoading: false,
        strucList: action.structures
      };
    case STRUC_BULK_CREATE_EXISTING_START:
      return {
        ...state,
        bulkCreateLoading: true,
        bulkCreateFail: false,
        bulkCreateSuccess: false
      };
    case STRUC_BULK_CREATE_EXISTING_SUCCESS:
      return {
        ...state,
        bulkCreateLoading: false,
        bulkCreateFail: false,
        bulkCreateSuccess: true
      };
    case STRUC_BULK_CREATE_EXISTING_FAIL:
      return {
        ...state,
        bulkCreateFail: true,
        bulkCreateLoading: false,
        bulkCreateSuccess: false
      };
    case STRUC_BULK_CREATE_SET_GRID_STORE:
      return {
        ...state,
        gridStore: action.gridStore
      };
    case STRUC_BULK_CREATE_STRUC_LIST_RESET:
      if (action.resetAll) return { ...initialState };
      return {
        ...initialState,
        gridStore: state.gridStore,
        retrieveStructuresSuccess: true,
        strucList: state.strucList
      };
    default: {
      return state;
    }
  }
}
